import _ from 'lodash';

import type { DrawerProps } from 'antd';
import type { ProDescriptionsActionType } from "@ant-design/pro-descriptions";
import type {ProFormProps} from '@ant-design/pro-form';

import React, { useRef } from 'react';
import {Button, Drawer, Space, Row, Col, Form, } from 'antd';
import {FooterToolbar} from '@ant-design/pro-layout';
import ProForm, {ModalForm, DrawerForm, } from '@ant-design/pro-form';

import FormLayout from './../../../../utils/ui/layout/FormLayout';
import OrganizationSelector from "./../../../system/pages/Organization/OrganizationSelector";
import PostSelector from "./../../../system/pages/Post/PostSelector";
import StaffSelector from "./../../../system/pages/Staff/StaffSelector";

import { StaffPosition } from './../../type/StaffPositionType';
import StaffPositionApi from '../../api/StaffPositionApi';
import { message } from 'antd';

export interface StaffPositionAddFormProps extends DrawerProps {
    onFail:()=>void,
    onSuccess:()=>void,
};



const StaffPositionAddForm:React.FC<StaffPositionAddFormProps> = (props)=>{

    const [form] = Form.useForm<StaffPosition>();
    const {onFail, onSuccess} = props;

    return (
        <Drawer
            title="新建角色"
            destroyOnClose={false}
            closable={false}
            width={960}
            extra={[
                <Button
                    key='closeBtn'
                    type='primary'
                    style={{backgroundColor:'red', border:0}}
                    onClick={onFail}
                >
                    关闭
                </Button>
            ]}
            {..._.omit(props, 'onFail', 'onSuccess')}
        >
            <ProForm
                submitter={{
                    render: (_, dom) => <div style={{textAlign:'right', marginTop:16}}><Space>{dom}</Space></div>,
                }}
                onFinish={async (values:  StaffPosition)=>{
                    await StaffPositionApi.addStaffPosition(values);
                    form.resetFields();
                    message.success("新建角色成功！");
                    if(onSuccess){
                        onSuccess();
                    }else{
                        onFail();
                    }
                    return true;
                }}
                form={form}
                layout={'horizontal'}
            >
                <Row>
                    <Col span={12}>
                        <OrganizationSelector
                            name={['orgId']}
                            label=""
                            tooltip=""
                            placeholder=""
                            required={false}
                            {...FormLayout.itemLayout.span12}
                        />
                    </Col>
                    <Col span={12}>
                        <PostSelector
                            name={['postId']}
                            label=""
                            tooltip=""
                            placeholder=""
                            required={false}
                            {...FormLayout.itemLayout.span12}
                        />
                    </Col>
                    <Col span={12}>
                        <StaffSelector
                            name={['staffId']}
                            label=""
                            tooltip=""
                            placeholder=""
                            required={false}
                            {...FormLayout.itemLayout.span12}
                        />
                    </Col>
                </Row>
            </ProForm>
        </Drawer>
    );
};

export default StaffPositionAddForm;